import "../../styles/pageskelton.css";
import SkeletonBox from "./SkeletonBox";

// Heights array — random-ish to mimic masonry
const HEIGHTS = [220, 300, 180, 260, 200, 340, 190, 270, 240, 310, 200, 180];

const GallerySkeleton = () => (
  <div className="sk-page">
    <SkeletonBox className="sk-header" />
    <SkeletonBox className="sk-inner-hero" />

    {/* Filter pills */}
    <div className="sk-gallery-filters">
      {[100, 90, 110, 95, 105].map((w, i) => (
        <SkeletonBox key={i} className="sk-filter-pill" style={{ width: w }} />
      ))}
    </div>

    {/* Masonry grid */}
    <div className="sk-gallery-masonry">
      {HEIGHTS.map((h, i) => (
        <SkeletonBox key={i} className="sk-gallery-img" style={{ height: h }} />
      ))}
    </div>
  </div>
);

export default GallerySkeleton;
